import React, { useEffect } from 'react';
import { data } from 'azure-maps-control';
import { useMap } from 'react-leaflet';

function FitIslandsCore({ islands, azureInstance, leafletInstance }) {
    useEffect(() => {
        const mapAzure = azureInstance;
        const mapLeaflet = leafletInstance;

        const entries = Object.values(islands || {});
        const id = setTimeout(() => {
            // Preparar posiciones para Azure: [lng, lat]
            const positions = entries
                .map(i => [parseFloat(i.coords[1]), parseFloat(i.coords[0])])
                .filter(([lng, lat]) => !isNaN(lng) && !isNaN(lat));

            // Para Leaflet necesitamos [lat, lng]
            const leafletCoords = entries
                .map(i => [parseFloat(i.coords[0]), parseFloat(i.coords[1])])
                .filter(([lat, lng]) => !isNaN(lat) && !isNaN(lng));

            if (mapLeaflet && leafletCoords.length > 0) {
                mapLeaflet.invalidateSize();
                if (leafletCoords.length === 1) {
                    mapLeaflet.setView(leafletCoords[0], 13);
                } else {
                    mapLeaflet.fitBounds(leafletCoords, { padding: [50, 50] });
                }
            }

            if (mapAzure && positions.length > 0) {
                if (positions.length === 1) {
                    const [lng, lat] = positions[0];
                    mapAzure.setCamera({ center: [lng, lat], zoom: 13, type: 'ease' });
                } else {
                    const bbox = data.BoundingBox.fromPositions(positions);
                    if (bbox) {
                        mapAzure.setCamera({ bounds: bbox, padding: 60, type: 'ease' });
                    }
                }
            }
        }, 0);

        return () => clearTimeout(id);
    }, [islands, azureInstance, leafletInstance]);

    return null;
}

export function LeafletFitIslandsWrapper(props) {
    const leafletMap = useMap();
    return <FitIslandsCore {...props} leafletInstance={leafletMap} />;
}

// Export principal: si se pasa prop 'map' o 'azureMap' la componente recibirá la instancia Azure directamente
export default function FitIslands(props) {
    // AzureMapBase inyecta 'map' en children; MapHome también puede pasar 'azureMap'
    const azureInstance = props.map || props.azureMap || null;
    return <FitIslandsCore {...props} azureInstance={azureInstance} />;
}

// ---- FitAssets: igual que FitIslandsCore pero para arrays de assets con lat/lng ----

function FitAssetsCore({ assets, azureInstance, leafletInstance }) {
    useEffect(() => {
        const coords = [];
        (assets || []).forEach(a => {
            const lat = parseFloat(a.lat);
            const lng = parseFloat(a.lng);
            if (leafletInstance) coords.push([lat, lng]);
            else if (azureInstance) coords.push([lng, lat]);
        });

        if (leafletInstance && coords.length > 0) {
            leafletInstance.invalidateSize();
            coords.length === 1
                ? leafletInstance.setView(coords[0], 13)
                : leafletInstance.fitBounds(coords, { padding: [50, 50] });
        }

        if (azureInstance && coords.length > 0) {
            const apply = () => {
                coords.length === 1
                    ? azureInstance.setCamera({ center: coords[0], zoom: 13, type: 'ease' })
                    : azureInstance.setCamera({ bounds: data.BoundingBox.fromPositions(coords), padding: 60, type: 'ease' });
            };
            azureInstance.events.addOnce('idle', apply);
            return () => azureInstance.events.remove('idle', apply);
        }
    }, [assets, azureInstance, leafletInstance]);
    return null;
}

export function LeafletFitAssetsWrapper(props) {
    const leafletMap = useMap();
    return <FitAssetsCore {...props} leafletInstance={leafletMap} />;
}

export function FitAssets(props) {
    const azureInstance = props.map || props.azureMap || null;
    return <FitAssetsCore {...props} azureInstance={azureInstance} />;
}
